/**
 * @param {import('@nuxtjs/axios').NuxtAxiosInstance} client
 * apiPaymentUrl
 * */

export default (client, { apiPaymentUrl }) => {
  const root = `${apiPaymentUrl}/cashbox_history`

  return {
    payHistory(paginationPayload = {}) {
      const { perPage = 20, isPayin = true, isPayout = true, offset = 0, onlyNew= false } = paginationPayload
      const url = root

      const params = {
        length: perPage,
        offset: offset,
        onlyNew: onlyNew,
      }

      let types = ''
      if (isPayin && !isPayout) types = 'payin'
      else if (!isPayin && isPayout) types = 'payout'
      if (types) {
        params['types[]'] = types
      }

      return client.get(url, { params })
    },
  }
}